/**
 * CSV-Export-Utility fuer tabellarische Daten.
 *
 * Server-side Export via POST /api/v1/export/csv: Backend liefert die CSV mit
 * Content-Disposition: attachment, der Browser triggert den Download über die
 * normale HTTP-Verbindung. Damit umgehen wir Chromes Mixed-Content-Filter, der
 * blob:- und data:-URL-Downloads bei HTTP blockt.
 */
export async function exportToCsv(
  filename: string,
  columns: { header: string; accessor: string }[],
  data: Record<string, unknown>[],
): Promise<void> {
  const token = localStorage.getItem('pm_token');
  const tenantId = localStorage.getItem('pm_tenant');

  const response = await fetch('/api/v1/export/csv', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(tenantId ? { 'X-Tenant-Id': tenantId } : {}),
    },
    body: JSON.stringify({ filename, columns, data }),
  });

  if (!response.ok) {
    throw new Error(`CSV-Export fehlgeschlagen: HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
